export const getIDs = (body: any) => {
  if (!body || typeof body !== 'string') {
    return []
  }

  const idRE =
    // eslint-disable-next-line
    /\|\@[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\|/g
  const ids = [...body.matchAll(idRE)].map(match => {
    const full = match[0]
    return full.slice(2, full.length - 1)
  })

  return ids
}
